import classNames from 'classnames';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { PureComponent } from 'react';
import { Spinner } from 'react-bootstrap';

import * as styles from './index.module.less';

export interface TableInlineButtonProps {
  id: string;
  className?: string;
  kind?: 'cancel';
  text: string;
  onClick?: () => Promise<void>;
}

@observer
export class TableInlineButton extends PureComponent<TableInlineButtonProps> {
  @observable
  submitting = false;

  handleClick = () => {
    this.submitting = true;
    this.props.onClick().finally(() => (this.submitting = false));
  };

  render() {
    const { className, kind } = this.props;

    return (
      <button
        className={classNames(
          'appearance-none',
          kind === 'cancel' && styles['btn-cancel'],
          className
        )}
        disabled={this.submitting}
        onClick={!this.submitting ? this.handleClick : null}
      >
        {this.props.text}
        {this.submitting && (
          <Spinner animation="border" size="sm" variant="primary" />
        )}
      </button>
    );
  }
}
